import { useMemo, useState } from 'react';

import { Box, Flex, rem } from '@vimeo/bokeh';

import { usePolls } from '../../../../store/firebase/interaction/poll';
import { T_ACTIVE, T_ARCHIVED } from '../../../../translations';
import { IPollPanel, TPollsList } from '../../../../types/interaction_tools';

export function usePollPanels(polls: TPollsList) {
  const [activePanelId, setActivePanelId] = useState<number>(0);

  const { activePolls, archivedPolls } = usePolls(polls);

  const panels: Array<IPollPanel> = useMemo(
    () => [
      {
        id: 0,
        label: (
          <Flex gap={rem(4)}>
            <Box>{T_ACTIVE}</Box>
            <Box color={'text-secondary'}>{activePolls.length || null}</Box>
          </Flex>
        ),
        polls: activePolls,
      },
      {
        id: 1,
        label: (
          <Flex gap={rem(4)}>
            <Box>{T_ARCHIVED}</Box>
            <Box color={'text-secondary'}>{archivedPolls.length || null}</Box>
          </Flex>
        ),
        polls: archivedPolls,
      },
    ],
    [activePolls, archivedPolls],
  );

  return { panels, activePolls, archivedPolls, activePanelId, setActivePanelId };
}
